/**
 * Client-generated idempotency keys for inventory add requests.
 *
 * The backend skips bulk-add lines whose key it has already applied, so a key
 * must stay the same across retries of one logical submission, and change for
 * every new intentional submission.
 */
export const createIdempotencyKey = (prefix: string): string =>
  `${prefix}-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`

/**
 * True when an axios-style error carries a server response — the outcome is
 * known, so the idempotency key should not be reused. Network errors and
 * timeouts have no response: the server may have committed, keep the key.
 */
export const isResponseError = (error: unknown): boolean =>
  Boolean((error as { response?: unknown })?.response)
